import fa from "./fa_IR";
export default {
    fa: fa,
};